import { ApiService } from '../../constants';
import { HttpService } from '../../utilities';

export const syncUser = (data: any) => {
  return HttpService.post(ApiService.icdc.module.syncUser.syncUser, data);
};

export const listUser = (data: any) => {
  return HttpService.get(ApiService.icdc.module.syncUser.listUser);
};

export const listEmail = (data: any) => {
  return HttpService.post(ApiService.icdc.module.syncUser.listEmail, data);
};
